// extracted by css-extract-rspack-plugin
export default {"root":"rIM9e","errorCat":"IOPhE"};